<textarea [froalaEditor]="options" [(froalaModel)]="value" (froalaModelChange)="changed()" (froalaInit)="initialize($event)"></textarea>
